import { render, staticRenderFns } from "./BranchValidation.vue?vue&type=template&id=21343375&scoped=true&lang=pug&"
import script from "./BranchValidation.vue?vue&type=script&lang=js&"
export * from "./BranchValidation.vue?vue&type=script&lang=js&"
import style0 from "./BranchValidation.vue?vue&type=style&index=0&id=21343375&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21343375",
  null
  
)

export default component.exports